<template>
	<div class="reg-rest-root" style="background: #f1f3f4;">
		<!-- <div class="header" @click="gotoLogin()">注册结果</div> -->
		<!-- <div class="top-bg" :style="{backgroundImage:'url('+topImage+')'}"></div> -->
		<div class="reg-rest-root-content">
			<div>
				<img src="../assets/registerLogo.png" class="logoimg">
			</div>
			<div class="content-top">
				<div style="font-weight: 500;color: #393939;font-size: 18px;margin-top: 1rem;">恭喜您</div>
				<div style="color: #393939;font-size: 12px;margin-top: 1rem;">并欢迎您加入嘉康利大家庭</div>
			</div>
			<div class="content-content">
				<div class="member-font" style="padding-top: 5px;">您的会员编号</div>
				<div class="member-number-font">{{ regMbNo }}</div>
				<div class="member-font" style="margin-top: 1.2rem;">您的会员密码</div>
				<div class="member-number-font">{{ regPwd }}</div>
				<div class="title-split">
					<div style=" height: 0rpx; width: 80px; border: 1px dashed #E6E6E6;"></div>
					<p style="color: #308A78;font-size: 14px;font-weight: 600;">温馨提示</p>
					<div style=" height: 0rpx; width: 90px; border: 1px dashed #E6E6E6;"></div>
				</div>
				<div class="bottom-font" style="color: #838383;">
					本月（注册成功当月）
					<span style="color: #308A78;">在“嘉康利官方商城”下单购买任意嘉康利产品并完成付款，</span>
					<span>即可成为正式会员。（积分商城内商品除外）如若未完成购买，您的会员编号将在本月最后一日24时失效。失效后您可重新注册。</span>
				</div>
				<div v-if="showToMall">
					<el-button @click="toRegister" class="agree-btn" >继续注册会员</el-button>
					<el-button @click="toMall" class="agree-btn" >立即逛逛商城</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { requestApi } from '@/utils/request';
	// let remotePicUrl = 'https://prodcdn.shaklee.com.cn';
	export default {
		data() {
			return {
				pageTitle:"嘉康利官方商城",
				showToMall:true,
				loadingInstance: null,
				// regMbNo:"12290351",
				// regPwd:"650462",
				regMbNo:"",
				regPwd:"",
				errMsg:"",
				jumpDown:2,
			};
		},
		created() {
    		document.title = this.pageTitle;
			// 获取查询参数
			this.regMbNo = this.$route.query.regMbNo;
			this.regPwd = this.$route.query.regPwd;
			// if (this.regMbNo == "" && this.regPwd == "") {
			// 	this.regMbNo = "10660767";
			// 	this.regPwd = "123456";
			// }
		},
		methods: {
			showLoadingBox() {
				this.loadingInstance = this.$loading({
					lock: true,
					body: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.6)',
					target: document.body,
					customClass: ' sk-loading-class'
				});
			},
			closeLoadingBox() {
				this.loadingInstance.close();
			},
			sleep(ms) {
				return new Promise(resolve => setTimeout(resolve, ms));
			},
			toRegister() {
				this.$router.push({ path: '/register' })
			},
			async toMall() {
				this.showLoadingBox();
				if (this.regMbNo == '' || this.regPwd == '') {
					return false;
				}
				// this.showToMall = false;
				await this.sleep(2000); // 等待2秒

				//自动登录并跳转
				const loginInfo = {
					source: 1,
					login_id: this.regMbNo,
					code: this.regPwd,
					policy_reading: 1,
					platform: 1
				};

				const funUrl = "/member/login";
				requestApi(funUrl, loginInfo, 1)
				.then((respData) => {
					console.log(respData);
					if (respData.code == 0 && respData.data.jump_url) {
						this.closeLoadingBox();
                    	window.location.href = respData.data.jump_url;
					} else {
						this.closeLoadingBox();
						this.errMsg = "登录失败请重试";
						this.$message({
							type: 'info',
							message: this.errMsg,
							duration: 2000
						});
						const jumpInterval = setInterval(() => {
							if (this.jumpDown > 0) {
								// console.log('即将跳转' + this.jumpDown);
								this.jumpDown--;
							} else {
								clearInterval(jumpInterval);
								this.jumpDown = 0;
								window.location.reload();
							}
						}, 500);
					}
				})
				.catch(error => {
					this.closeLoadingBox();
					return;
				});
			},
			gotoLogin(){

			}
		}
	};
</script>
<style lang="scss">
.header {
	background: #f1f3f4;
	position: fixed;
	z-index: 999;
	text-align: center;
	width: 100%;
	line-height: 35px;
	font-weight: 600;
	color: #014134;
	font-size: 20px;
	padding-top: 3vh;
	padding-bottom: 5px;
}

	.reg-rest-root {
		width: 100%;
		height: 100vh;
		overflow: auto;
		background: #fff;
		font-family: pingfang;
		background-size: cover;
		background-position: 20% 90%;
		background-attachment: fixed; /* 背景图片固定在视口中 */
		min-width: 350px;
		min-height: 100vh;
		position: relative;

		.logoimg {
				width: 100px;
				height: 25px;
				padding-top: 10px;
		}

		.reg-rest-root-content {
			position: fixed;
			width: 90%;
			margin-top: 2rem;
			margin-left: 3%;
		}

		.content-top {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.content-content {
			width: 100%;
			height: 800rpx;
			margin-top: 3rem;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;

			.member-font {
				font-family: PingFang;
				font-style: Semibold;
				font-size: 12px;
				text-align: Center;
				font-weight: 600;
				color: #161616;
				margin-top: 1.5rem;
			}

			.member-number-font {
				color: #308A78;
				font-size: 1.5rem;
				font-weight: 750;
				font-style: normal;
				margin-top: 1px;
			}

			.title-split {
				margin-top: 15px;
				color: #308A78;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-around;
				font-weight: 600;
				font-size: 14px;
				width:90%;
				padding-left: 7%;
			}

			.bottom-font {
				width:85%;
				text-align: left;
				font-weight: 400;
				padding-left: 10%;
				font-size: 10px;
			}

			.agree-btn {
				margin-top: 1.2rem;
				margin-left: 3%;
				margin-bottom: 1rem;
				width: 40%;
				height: 45px;
				border-radius: 25px;
				border: none;
				background-color: #173f35;
				color: #fff;
			}

			.no-agree {
				display: flex;
				text-align: center;
				justify-content: center;
				justify-items: center;
				align-items: center;
				width: 224rpx;
				height: 88rpx;
				line-height: 88rpx;
				color: #308A78;
				font-weight: 500;
				font-size: 32rpx;
				background: #FFFFFF;
				margin-right: 6rpx;
				border: 2rpx solid #308A78;
				border-radius: 49rpx;
			}

			.yes-agree {
				display: flex;
				text-align: center;
				justify-content: center;
				justify-items: center;
				align-items: center;
				width: 300rpx;
				height: 88rpx;
				line-height: 88rpx;
				font-weight: 500;
				margin-left: 6rpx;
				color: #FFFFFF;
				font-size: 32rpx;
				background: #308A78;
				border-radius: 49rpx;
			}
		}

	}
	.el-message {
		background-color: black;
		/* 背景颜色 */
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		left: 50% !important;
		top: 40% !important;
		max-width: 100%;
		min-width: unset !important; 
		padding-left: 7px !important;
		padding-right: 7px !important;
	}

	/* 自定义消息文本样式 */
	.el-message__content {
		font-size: 12px;
		/* 字体大小 */
		/* 文字颜色 */
		color: white !important;
	}
	.el-message__icon {
		display: none !important;
	}

</style>


// WEBPACK FOOTER //
// src/page/registerResult.vue